class SessionError extends Error {
  constructor(message: string | number) {
    super(`${message}`);
    Object.setPrototypeOf(this, SessionError.prototype);
  }
}

export class SetSessionIdError extends SessionError {
  constructor(message: string | number) {
    super(message);
    Object.setPrototypeOf(this, SetSessionIdError.prototype);
    this.name = 'SetSessionIdError';
  }
}
